export default "__VITE_ASSET__bUHOmgj0v0e8gORvphau3Q__"